export enum End {
    SERVER = 'SERVER',
    CLIENT = 'CLIENT',
    DEVICE = 'DEVICE'
}
